import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ApErrorHandlerService } from '@ap/error';

import { MijnHttpErrorService } from './mijn-http-error.service';

@Injectable()
export class MijnErrorHandler extends ApErrorHandlerService {
    public constructor(
        @Inject(DOCUMENT) private readonly document: Document,
        @Inject('webComponentName') private readonly identifier: string,
        private readonly mijnHttpErrorService: MijnHttpErrorService
    ) {
        super();
    }

    public override handleError(error: any): void {
        if (error?.code === -100) {
            console.warn(`Suppressed NG0100 error: ${error}`); //NOSONAR
            return;
        }
        const webElement = this.document.querySelector(`${this.identifier}-web`);
        let mijnError: HttpErrorResponse = error;
        if (error.cause instanceof HttpErrorResponse) {
            mijnError = error.cause;
        } else if (error.rejection instanceof HttpErrorResponse) {
            mijnError = error.rejection;
        }
        if (webElement && this.mijnHttpErrorService.shouldNavigateToError(mijnError)) {
            const event: CustomEvent = new CustomEvent('interceptorError', {
                bubbles: true,
                detail: {
                    status: mijnError.status,
                    url: mijnError.url,
                    message: mijnError.message
                }
            });
            webElement.dispatchEvent(event);
        } else {
            super.handleError(error);
        }
    }
}
